import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=c33b394c&scoped=true"
import script from "./PaymentsTable.vue?vue&type=script&lang=js"
export * from "./PaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentsTable.vue?vue&type=style&index=0&id=c33b394c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b394c",
  null
  
)

export default component.exports